/**
 * 17 Oct 2026 — the Companion incident report's photos, sent one by one after the report (the volunteer's own link, or
 * the office entering it from the Companion tab). A photo counts as added only when the server took it: an answer that
 * is not OK, the link's own "not valid" answer (HTTP 200 with `ok: false`), an answer that is not JSON, or no
 * connection at all leaves it not added. The caller says which, and offers Try again for those only.
 */

/** Sends each photo with `send`; resolves with the photos the server did NOT take (empty: every one was added). */
export async function sendIncidentPhotos(files: readonly File[], send: (file: File) => Promise<Response>): Promise<File[]> {
  const notAdded: File[] = [];
  for (const file of files) {
    try {
      const res = await send(file);
      const body = (await res.json().catch(() => null)) as { ok?: unknown } | null;
      if (!res.ok || !body || body.ok === false) notAdded.push(file);
    } catch {
      notAdded.push(file);
    }
  }
  return notAdded;
}
